import React from "react";
import { Trans, useTranslation } from "react-i18next";

function RewardLevels({ rewardLevels, userOrderAmount }) {
  const { t } = useTranslation();

  const sortedLevels = [...rewardLevels].sort(
    (a, b) => parseFloat(a.min_order_value) - parseFloat(b.min_order_value)
  );

  const currentTierIndex = sortedLevels.findIndex((tier) => {
    const min = parseFloat(tier.min_order_value);
    const max = tier.max_order_value
      ? parseFloat(tier.max_order_value)
      : Infinity;
    return userOrderAmount >= min && userOrderAmount <= max;
  });

  if (currentTierIndex === -1) return null;

  const currentTier = sortedLevels[currentTierIndex];
  const nextTier = sortedLevels[currentTierIndex + 1];

  const amountAway = nextTier
    ? parseFloat(nextTier.min_order_value) - userOrderAmount
    : null;

  const heavyFontStyle = {
    fontFamily: "Futura Heavy, sans-serif",
  };

  const messageStyle = {
    padding: "15px",
    border: "1px solid #dee2e6",
    textAlign: "center",
    color: "#003366",
    fontSize: "15px",
    letterSpacing: "0.5px",
  };

  return (
    <div style={messageStyle}>
      {nextTier && amountAway > 0 ? (
        <>
          <Trans
            i18nKey="rewards.away_message"
            values={{
              amount: amountAway.toFixed(2),
              points: `${parseFloat(nextTier.reward_points)}`,
            }}
            components={{
              bold1: <span style={heavyFontStyle} />,
            }}
          />
          <br />
        </>
      ) : currentTierIndex === sortedLevels.length - 1 ? (
        <Trans
          i18nKey="rewards.max_level_unlocked"
          values={{
            points: `${parseFloat(currentTier.reward_points)}`,
          }}
          components={{
            bold: <span style={heavyFontStyle} />,
          }}
        />
      ) : null}
    </div>
  );
}

export default RewardLevels;
